module.exports = __webpack_public_path__ + "img/Sk_resident2ru.00b4d811.jpg";